import { useState,useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Row,Col,Card,Container,Button, Form, FormGroup, Input, Label, Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from "reactstrap";
import { useForm } from "react-hook-form";
import { useParams } from "react-router-dom";
import { usersTitle,addUserTitle, CreateAccount,  EmailAddress, ForgotPassword, Href, Password, RememberPassword, SignIn, SignInAccount, SignInWith } from "../../constants";
import ApiService from "../../services/apiService";
import Auth from "../../services/authService";
import Breadcrumbs from "../../coreComponents/breadcrumbs";


const SignUpForm = ({userId}:{userId:any}) => {
  const navigate = useNavigate();
  const [isPasswordVisible, setPasswordVisible] = useState(false);
  const toggle = () => setPasswordVisible(!isPasswordVisible);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggleDropdown = () => setDropdownOpen(prev => !prev);
  const [selectedRole, setSelectedRole] = useState('');
  const { register, handleSubmit, formState: { errors } ,setValue} = useForm();
  const [previewUrl,setPreviewUrl] = useState();
  const [userImage, setUserImage] = useState(null);

  useEffect(()=>{
       const getUser = async () =>{

        try{
            const response = await ApiService.axiosApi(`/auth/${userId}`,{
              method: 'GET'
            })

            if(response.success){
               const userData = response.data;
               console.log(userData)
               setValue("Username",userData.userName)
               setValue("phoneNumber",userData.phoneNumber)
               setValue("email",userData.email)
            }
            else{
                console.log();
            }
        }catch(error){
            console.log(error)
            toast.error("Unable To Fetch User" )
        }
       }
       getUser();
  },[])

  const handleSelectRole = (role: string) => {
    setSelectedRole(role);
  }

  const onSubmit = async (data: any) => {
    try {
        const registerData = {
            UserName: data.Username,  
            Password: data.password,
            Email: data.email,
            PhoneNumber: data.phoneNumber,
            Roles: [selectedRole]  
          };
      const response = await Auth.register(registerData);
      
      if (response.success) {
        toast.success("Registration successful! Please login.");
        navigate('/login');
      }
    } catch (error: any) {
      const errorMessage = error.response?.data?.message || 
                         error.message || 
                         "An unexpected error occurred";
      toast.error(errorMessage);
    }
  };
  
  return (
    <>
     <Breadcrumbs mainTitle={usersTitle} parent={addUserTitle} />
    <Col xl="12" className="mx-auto my-auto">
      <Card className="p-5">
    <Form className="theme-form" onSubmit={handleSubmit(onSubmit)}>
      <h3>Add User</h3>
      <p>{"Enter your details to add user"}</p>

      
      
      <Row>
        <Col md = {6}>
      <FormGroup>
        <Label className="col-form-label">Name</Label>
        <input 
          className="form-control" 
          type="text" 
          placeholder="Enter your name"
          {...register("Username", { 
            required: "Name is required",
            minLength: {
              value: 2,
              message: "Name must be at least 2 characters"
            }
          })} 
        />
        {errors.name && <p className="text-danger mt-1">{errors.name.message?.toString()}</p>}
      </FormGroup>
      </Col>
        <Col md={6}>
        <FormGroup>
        <Label className="col-form-label">Phone Number</Label>
        <input 
          className="form-control" 
          type="tel" 
          placeholder="Phone Number"
          {...register("phoneNumber", { 
            required: "Phone number is required",
            pattern: {
              value: /^[0-9]{10}$/,
              message: "Please enter a valid 10-digit phone number"
            }
          })} 
        />
        {errors.phoneNumber && <p className="text-danger mt-1">{errors.phoneNumber.message?.toString()}</p>}
      </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col md={6}>
      <FormGroup>
        <Label className="col-form-label">{EmailAddress}</Label>
        <input 
          className="form-control" 
          type="email" 
          placeholder=" Email"
          {...register("email", { 
            required: "Email is required",
            pattern: {
              value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
              message: "Invalid email address"
            }
          })} 
        />
        {errors.email && <p className="text-danger mt-1">{errors.email.message?.toString()}</p>}
      </FormGroup>
      </Col>
      <Col md={6}>
      <FormGroup>
        <Label className="col-form-label">{Password}</Label>
        <div className="form-input position-relative">
          <input 
            className="form-control" 
            type={isPasswordVisible ? "text" : "password"} 
            placeholder="Password"
            {...register("password", { 
              required: "Password is required",
              
            })} 
          />
          <div className="show-hide" onClick={toggle}>
            <span className={!isPasswordVisible ? "show" : ""}> </span>
          </div>
        </div>
        {errors.password && <p className="text-danger mt-1">{errors.password.message?.toString()}</p>}
      </FormGroup>
      </Col>
      </Row>
     

      

      <FormGroup>
        <div className="form-group " >
           <Dropdown  isOpen={dropdownOpen} toggle={toggleDropdown} className="custom-dropdown-wrapper" >
            <DropdownToggle
             className="custom-dropdown-toggle d-flex align-items-center justify-content-between"
             style={{
               backgroundColor: '#007bff',
               borderColor: '#007bff',
               color: '#fff',
               fontWeight: 500,
               borderRadius: '6px',
               padding: '8px 16px',
               width: '200px',
             }}
              color="primary"
             >
               
                {selectedRole? selectedRole : "Select Role"}
            </DropdownToggle>
            <DropdownMenu
            className="custom-dropdown-menu"
            style={{
              maxHeight: '200px',
              overflowY: 'auto',
              boxShadow: '0 0.5rem 1rem rgba(0, 0, 0, 0.1)',
              borderRadius: '8px',
              padding: '8px 0',
              
            }}>
                <DropdownItem onClick={() => handleSelectRole("Administrator")}>Administrator</DropdownItem>
                <DropdownItem onClick={() => handleSelectRole("Operator")} >Operator</DropdownItem>
                <DropdownItem onClick={() => handleSelectRole("Enginner")}>Enginner</DropdownItem>
                <DropdownItem onClick={() => handleSelectRole("Client")}>Client</DropdownItem>
                <DropdownItem onClick={() => handleSelectRole("Farmer")}>Farmer</DropdownItem>
            </DropdownMenu>    
           </Dropdown>
        </div>
      </FormGroup>

      <div className="form-group mb-0">
        <div className="checkbox p-0">
          <Input id="checkbox1" type="checkbox" />
          <Label className="text-muted" htmlFor="checkbox1">{RememberPassword}</Label>
        </div>
        
      </div>
      <div className="form-group mb-0 d-flex justify-content-end">
        
          <Button color="primary" className="me-1" >Create User</Button>
          <Button color="danger" onClick={()=>navigate(-1)}>Back </Button>
        </div>
     

    </Form>
    </Card>
    </Col>
    </>
  );
};

export default SignUpForm;